import { default as React } from "react";
import { Container, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { getBusinessLabel } from "../utils";
import CustomerOrdersSpinner from "./CustomerOrdersSpinner";

export default function MobileMenu(props) {
  const { userInfo, isTabletOrMobile, notDeliveredItemExist, signoutHandler } =
    props;
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container
        className={
          isTabletOrMobile ? "upmedium-container-mobile" : "upmedium-container"
        }
      >
        <LinkContainer to="/category/order">
          <Link to="/category/order" className="textDecorationNone">
            <div>
              <Navbar.Brand>{userInfo && userInfo.businessName}</Navbar.Brand>
              <div className="text-white text-muted">
                {userInfo &&
                  (userInfo.isHelpDesk
                    ? userInfo?.client?.businessName || "Bağlantı Yok"
                    : getBusinessLabel(userInfo.businessType))}
              </div>
            </div>
          </Link>
        </LinkContainer>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto  w-100  justify-content-end">
            {userInfo ? (
              <NavDropdown title={userInfo.name} id="basic-nav-dropdown">
                {userInfo.isBusinessOwner && (
                  <LinkContainer to="/profile">
                    <NavDropdown.Item className="aligned-dropdown-item">
                      <i className="fas fa-user-edit"></i>&nbsp; Hesap
                      Bilgilerim
                    </NavDropdown.Item>
                  </LinkContainer>
                )}
                <Link
                  className="dropdown-item aligned-dropdown-item"
                  to="#signout"
                  onClick={signoutHandler}
                >
                  <i className="fa fa-sign-out"></i>&nbsp; Çıkış Yap
                </Link>
              </NavDropdown>
            ) : (
              <Link className="nav-link" to="/signin">
                Giriş Yap
              </Link>
            )}
            {userInfo &&
              userInfo.isAdmin &&
              ((userInfo.isHelpDesk && userInfo.client) ||
                !userInfo.isHelpDesk) && (
                <NavDropdown title="İşlemler" id="admin-nav-dropdown">
                  <LinkContainer to="/admin/expenses">
                    <NavDropdown.Item className="aligned-dropdown-item">
                      <i className="fas fa-money-bill-wave"></i>
                      <span>Giderler</span>
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to={`/reportsummary`}>
                    <NavDropdown.Item className="aligned-dropdown-item">
                      <i className="fa fa-line-chart"></i>
                      <span> Raporlar</span>
                    </NavDropdown.Item>
                  </LinkContainer>

                  <LinkContainer to="/admin/orders-filter">
                    <NavDropdown.Item className="aligned-dropdown-item">
                      <i className="fas fa-search"></i>
                      <span> Siparişlerde Ara</span>
                    </NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/admin/management">
                    <NavDropdown.Item className="aligned-dropdown-item">
                      <i className="fas fa-store"></i>
                      <span>Mağaza Yönetimi</span>
                    </NavDropdown.Item>
                  </LinkContainer>
                </NavDropdown>
              )}
            <CustomerOrdersSpinner
              userInfo={userInfo}
              isTabletOrMobile={isTabletOrMobile}
              notDeliveredItemExist={notDeliveredItemExist}
            ></CustomerOrdersSpinner>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
